import { CabinetWrapper } from '../../shared/cabinet-wrapper';
import { useParams, useSearchParams } from 'react-router-dom';
import { useGetBuyersIncomingRequestQuery } from '../../app/api';
import { SingleDeal } from '../../shared/single-deal';
import { getFetchEror } from '@/app/helpers';
import { Alert } from '@mui/material';
import ComponentWithLoader from '@/shared/ComponentWithLoader/ComponentWithLoader';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@/shared/page-title';

export const SingleBuyerIncomingRequest = () => {
  const { t } = useTranslation();
  const { id = '' } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const backUrl = searchParams.get('backUrl');

  const { data, isLoading, error } = useGetBuyersIncomingRequestQuery(id, {
    skip: !id,
  });

  const isReverseFactoring = data?.data?.isReverseFactoring;

  return (
    <CabinetWrapper>
      <ComponentWithLoader isLoading={isLoading}>
        {data ? (
          <>
            <PageTitle
              title={t('request') + ` №${data.data.number}`}
              date={data.data.createdAt}
              backUrl={encodeURIComponent(
                backUrl || '/buyer/incoming-requests'
              )}
            />
            <SingleDeal
              data={data?.data}
              type={isReverseFactoring ? 'seller' : 'buyer'}
              factorBranch={data?.factor?.branch}
            />
          </>
        ) : (
          <Alert severity='error'>{getFetchEror(error)}</Alert>
        )}
      </ComponentWithLoader>
    </CabinetWrapper>
  );
};
